import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceCard.css';

const ServiceCard = ({ icon: Icon, title, description, link }) => {
  return (
    <Link to={link} className="service-card">
      <div className="service-icon">
        <Icon />
      </div>
      <h3 className="service-title">{title}</h3>
      <p className="service-description">{description}</p>
      <span className="service-arrow">←</span>
    </Link>
  );
};

export default ServiceCard;
